export default function R_Compiler() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Compiler Component</h1>
      <p>This is the R_Compiler tutorial section.</p>
    </div>
  );
}
